import { Link, NavLink } from "react-router-dom";
import { TreeDeciduous, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/lib/i18n";
import { LangToggle } from "@/components/LangToggle";

const navCls = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 ${isActive ? "text-[#D96B43]" : "text-[#52635B] hover:text-[#1E3A2B]"}`;

export const Header = () => {
  const { user, login, logout } = useAuth();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FDFBF7]/90 border-b border-[#E5DEC9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-home-logo" className="flex items-center gap-3 group">
          <span className="w-10 h-10 rounded-full bg-[#1E3A2B] grid place-items-center transition-transform duration-300 group-hover:rotate-12">
            <TreeDeciduous className="w-5 h-5 text-[#FDFBF7]" />
          </span>
          <span className="leading-tight whitespace-nowrap">
            <span className="block font-serif text-base sm:text-lg font-semibold text-[#1E3A2B]">{t("Vats Family Tree")}</span>
            <span className="block font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#D96B43]">{t("Life long Jurny")}</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-5">
          <NavLink to="/" end className={navCls} data-testid="nav-tree-link">{t("The Tree")}</NavLink>
          <NavLink to="/relations" className={navCls} data-testid="nav-relations-link">{t("Relations")}</NavLink>
          <NavLink to="/events" className={navCls} data-testid="nav-events-link">{t("Events")}</NavLink>
          <NavLink to="/album" className={navCls} data-testid="nav-album-link">{t("Album")}</NavLink>
          <NavLink to="/celebrations" className={navCls} data-testid="nav-celebrations-link">{t("Celebrations")}</NavLink>
          <NavLink to="/join" className={navCls} data-testid="nav-join-link">{user?.person ? t("My profile") : t("Join")}</NavLink>
          {user && <NavLink to="/approvals" className={navCls} data-testid="nav-approvals-link">{t("Approvals")}</NavLink>}
          {user?.can_vote && <NavLink to="/history" className={navCls} data-testid="nav-history-link">{t("History")}</NavLink>}
          {user?.is_admin && <NavLink to="/admin" className={navCls} data-testid="nav-admin-link">{t("Admin")}</NavLink>}
        </nav>
        <div className="flex items-center gap-3">
        <LangToggle />
        {user ? (
          <div className="flex items-center gap-3">
            {user.picture && <img src={user.picture} alt="" className="w-9 h-9 rounded-full border border-[#E5DEC9]" />}
            <span className="hidden sm:block text-sm text-[#52635B]" data-testid="header-user-name">{user.name}</span>
            <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-btn" aria-label="Sign out">
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        ) : (
          <Button onClick={login} data-testid="header-signin-btn" className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20] px-4 sm:px-6">
            <span className="sm:hidden">{t("Sign in")}</span><span className="hidden sm:inline">{t("Sign in with Google")}</span>
          </Button>
        )}
        </div>
      </div>
      <nav className="lg:hidden flex justify-center gap-4 pb-3 text-xs flex-wrap">
        <NavLink to="/" end className={navCls} data-testid="mnav-tree-link">{t("Tree")}</NavLink>
        <NavLink to="/relations" className={navCls} data-testid="mnav-relations-link">{t("Relations")}</NavLink>
        <NavLink to="/events" className={navCls} data-testid="mnav-events-link">{t("Events")}</NavLink>
        <NavLink to="/album" className={navCls} data-testid="mnav-album-link">{t("Album")}</NavLink>
        <NavLink to="/celebrations" className={navCls} data-testid="mnav-celebrations-link">{t("Dates")}</NavLink>
        <NavLink to="/join" className={navCls} data-testid="mnav-join-link">{user?.person ? t("Me") : t("Join")}</NavLink>
        {user && <NavLink to="/approvals" className={navCls} data-testid="mnav-approvals-link">{t("Approvals")}</NavLink>}
        {user?.can_vote && <NavLink to="/history" className={navCls} data-testid="mnav-history-link">{t("History")}</NavLink>}
        {user?.is_admin && <NavLink to="/admin" className={navCls} data-testid="mnav-admin-link">{t("Admin")}</NavLink>}
      </nav>
    </header>
  );
};
